export default {
  criterios: [
    {
      numeroItem: null,
      sequencia: 1,
      operadorLogico: null,
      tipoCriterio: "",
      operadorRelacional: null,
      tipoValor: null,
      tipoValorLogico: false,
      tipoValorNumerico: false,
      tipoValorPercentual: false,
      valorNumerico: null,
      valorPercentual: null,
      valorLogico: null,
      valor: null,
      itemId: null
    }
  ],
  erros:[]
}
